// src/font.ts
var fontPretendard = "Pretendard";
var Pretendard = `
@font-face {
  font-display: swap;
  font-family: 'Pretendard';
  font-weight: 100;
  font-style: normal;
  src: local(Pretendard Thin), url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Thin.subset.woff2') format("woff2"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Thin.subset.woff') format("woff"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Thin.otf');
}

@font-face {
  font-display: swap;
  font-family: 'Pretendard';
  font-weight: 200;
  font-style: normal;
  src: local(Pretendard ExtraLight), url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-ExtraLight.subset.woff2') format("woff2"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-ExtraLight.subset.woff') format("woff"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-ExtraLight.otf');
}

@font-face {
  font-display: swap;
  font-family: 'Pretendard';
  font-weight: 300;
  font-style: normal;
  src: local(Pretendard Light), url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Light.subset.woff2') format("woff2"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Light.subset.woff') format("woff"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Light.otf');
}

@font-face {
font-display: swap;
  font-family: 'Pretendard';
  font-weight: 400;
  font-style: normal;
  src: local(Pretendard Regular), url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Regular.subset.woff2') format("woff2"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Regular.subset.woff') format("woff"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Regular.otf');
}

@font-face {
font-display: swap;
  font-family: 'Pretendard';
  font-weight: 500;
  font-style: normal;
  src: local(Pretendard Medium), url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Medium.subset.woff2') format("woff2"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Medium.subset.woff') format("woff"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Medium.otf');
}

@font-face {
font-display: swap;
  font-family: 'Pretendard';
  font-weight: 600;
  font-style: normal;
  src: local(Pretendard SemiBold), url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-SemiBold.subset.woff2') format("woff2"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-SemiBold.subset.woff') format("woff"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-SemiBold.otf');
}

@font-face {
font-display: swap;
  font-family: 'Pretendard';
  font-weight: 700;
  font-style: normal;
  src: local(Pretendard Bold), url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Bold.subset.woff2') format("woff2"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Bold.subset.woff') format("woff"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Bold.otf');
}

@font-face {
font-display: swap;
  font-family: 'Pretendard';
  font-weight: 800;
  font-style: normal;
  src: url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-ExtraBold.subset.woff2') format("woff2"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-ExtraBold.subset.woff') format("woff"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-ExtraBold.otf');
}

@font-face {
font-display: swap;
  font-family: 'Pretendard';
  font-weight: 900;
  font-style: normal;
  src: url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Black.subset.woff2') format("woff2"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Black.subset.woff') format("woff"),
  url('https://static.spartacodingclub.kr/static/fonts/Pretendard/Pretendard-Black.otf');
}

`;

export {
  fontPretendard,
  Pretendard
};
